module.exports = __webpack_public_path__ + "static/media/upload.d3b4e219.svg";